export default __webpack_public_path__ + "static/media/codale-logo-bw.0cf61127.png";